module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchbar":{"placeholder":"Search by company, compliance admin name or email"}}}')
  delete Component.options._Ctor
}
